export { PDFComponent } from './PDFComponent';
